<template>
  <div
    class="card card-secondary"
    :class="{ 'card-empty': !isFetched || graphIsEmpty() }"
  >
    
    <h3 v-if="isTrailer">Windsnelheid afgelopen uur</h3>
    <h3 v-else>Windsnelheid afgelopen 6 uur</h3>

    <LineChart
      ref="chartSpeed"
      v-if="loaded && !graphIsEmpty()"
      :time-stamps="timeStamps"
      :chart-data="chartData"
      :chart-options="chartOptions"
      :height="200"
    />
    <EmptyCardBody v-else />
  </div>
</template>

<script>
import { defineComponent } from "@vue/composition-api";
import EmptyCardBody from "@/components/EmptyCardBody.vue";

import { Line as LineChart } from "vue-chartjs/legacy";
import { defaults } from "chart.js";

export default defineComponent({
  name: "WindSpeedLastHour",
  components: { LineChart, EmptyCardBody },
  props: {
    windSpeedData: Array,
    timeStamps: Array,
    isFetched: Boolean,
    isTrailer: Boolean,
  },
  data: (props) => ({
    loaded: props.isFetched,
    chartData: {},
    chartOptions: {},
    timeStampOptions: { hour: "2-digit", minute: "2-digit" },
  }),
  methods: {
    getStartAndFinalTimestamps() {
      const finalTime = new Date(this.timeStamps[this.timeStamps.length - 1]);
      return `${this.getInitialTimestamp()} - ${finalTime.toLocaleTimeString(
        [],
        this.timeStampOptions
      )}`;
    },
    getInitialTimestamp() {
      const initialTime = new Date(this.timeStamps[0]);
      return initialTime.toLocaleTimeString([], this.timeStampOptions);
    },
    graphIsEmpty() {
      return this.timeStamps.length === 0;
    },
  },
  mounted() {
    // console.log("SPEEDLASTHOUR || mounted", this.isFetched, this.windSpeedData);
    defaults.font.family = "Oswald, sans-serif";
    defaults.font.size = 16;
    defaults.font.color = "#000";

    this.chartOptions = {
      responsive: true,
      animation: false,
      plugins: {
        legend: {
          position: "none",
        },
        title: {
          display: true,
          position: "bottom",
          text: this.getStartAndFinalTimestamps(),
          color: "#333",
          padding: {
            top: 20,
          },
          font: {
            size: 16,
          },
        },
      },
      scales: {
        y: {
          min: 0,
          max: 40,
          grid: {
            drawBorder: false,
            tickColor: "#84C9DC",
            tickBorderDash: [0, 1],
          },
          ticks: {
            beginAtZero: true,

            min: 0,
            max: 40,
            stepSize: 8,
            color: "#333",
            font: {
              family: "Oswald, sans-serif",
              size: 14,
            },
          },
        },
        x: {
          display: false,
        },
      },
    };

    this.chartData = {
      labels: this.windSpeedData,
      datasets: [
        {
          borderColor: "#84C9DC",
          cubicInterpolationMode: "default",
          data: this.windSpeedData,
          pointRadius: 0,
          pointHoverRadius: 0,
        },
      ],
    };

  },
  updated() {
    this.$nextTick(() => {
    //   if (!this.graphIsEmpty) {
      const chartInstance = this.$refs.chartSpeed;
      setTimeout(() => {
        chartInstance.updateChart();
      }, 1000);
    // }
    });
  },
});
</script>
